@let isLoading = manualDeliverableStatus() === undefined && !creatorBriefingMode();

<div class="flex flex-col gap-0.5 w-max">
  <div class="flex items-center gap-3">
    @if (actionsVisible() || statusVisible()) {
      <span class="text-xs text-shikenso-purple-base-60"> {{ 'field.status' | translate }}: </span>
    }

    @if (isLoading) {
      <ngx-skeleton-loader class="h-6" [theme]="{ width: '82px', height: '24px', 'border-radius': '100vw' }" />
    } @else {
      @if (actionsVisible()) {
        <div
          class="flex items-center justify-center w-max"
          matTooltipPosition="left"
          [matTooltipDisabled]="
            updatedManualDeliverableStatus()?.processed || !updatedManualDeliverableStatus() || tooltipHidden()
          "
          [matTooltip]="'shared.deliverableActions.processing' | translate"
        >
          <div
            mat-flat-button
            class="px-2 rounded-full flex items-center justify-center h-6"
            [style.background-color]="colors().background"
            [style.color]="colors().text"
            (click)="$event.stopPropagation()"
          >
            @if (store.loading$()) {
              <div class="flex items-center justify-center w-10">
                <app-dots-spinner />
              </div>
            } @else {
              <span class="text-xs font-bold">
                {{ statusLabel() }}
              </span>
            }
          </div>
        </div>

        <button mat-icon-button [disabled]="store.loading$()" [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger">
          <app-icon src="icons/edit.svg" [size]="16" />
        </button>

        <mat-menu #menu="matMenu">
          @if (!store.loading$()) {
            @for (item of manualMenu().menu; track item.key) {
              <button mat-menu-item (click)="onManualMenuClick(item.key, $event, menuTrigger)">
                {{ item.label | translate }}
              </button>
            }
          }
        </mat-menu>
      } @else if (statusVisible()) {
        <div
          class="flex items-center justify-center w-max"
          matTooltipPosition="left"
          [matTooltip]="
            !updatedManualDeliverableStatus()?.processed && updatedManualDeliverableStatus()
              ? ('shared.deliverableActions.processing' | translate) +
                ' ' +
                ('shared.deliverableActions.statusCannotBeChangeCampaignNotLive' | translate)
              : ('shared.deliverableActions.statusCannotBeChangeCampaignNotLive' | translate)
          "
          [matTooltipDisabled]="tooltipHidden()"
        >
          <div
            mat-flat-button
            class="px-2 rounded-full flex items-center justify-center h-6"
            [style.background-color]="colors().background"
            [style.color]="colors().text"
            (click)="$event.stopPropagation()"
          >
            <span class="text-xs font-bold">
              {{ statusLabel() }}
            </span>
          </div>
        </div>
      }
    }
  </div>

  @if (!exportMode() && !creatorBriefingMode()) {
    <span class="text-[10px] text-shikenso-purple-base-40">
      @if (isLoading) {
        <div class="w-full h-6 flex items-center">
          <ngx-skeleton-loader class="h-4" [theme]="{ width: '138px', height: '16px', 'border-radius': '4px' }" />
        </div>
      } @else {
        @if (actionsVisible()) {
          @if (hasManualStatus()) {
            {{ 'shared.deliverableActions.manualOverrideCanBeChanged' | translate }}
          } @else {
            {{ 'shared.deliverableActions.manualOverridePossible' | translate }}
          }
        } @else if (statusVisible()) {
          {{ 'shared.deliverableActions.manualOverrideNotPossible' | translate }}
        }
      }
    </span>
  }
</div>
